import * as types from './type'

const initialState = {
    data: [],
    loading: false,
    crePoLoad: false,
    loadPositions: false,
}

export const departmentsIdRuducer = (state = initialState, action) => {

    switch (action.type) {

        case types.GET_DEPARTMENTS_ID: 
            return {
                ...state,
                ...{ loading: true }
            }
        
        case types.GET_DEPARTMENTS_ID_SUCCESS:
            return {
                ...state,
                ...{
                    data: action.payload.data,
                    loading: false
                }
            }
        
        case types.GET_DEPARTMENTS_ID_FAIL:
            {
                return {
                    ...state,
                    ...{ data: [], loading: false }
                }
            }

        case types.CREATE_POSITIONS: 
            return {
                ...state,
                crePoLoad: true,
            }
        
        case types.CREATE_POSITIONS_SUCCESS:
            return {
                ...state,
                crePoLoad: false,
            }
//edit
        case types.PUT_POSITIONS: 
            return {
                ...state,
                loadPositions: true,
            }
        
        case types.PUT_POSITIONS_SUCCESS:
            return {
                ...state,
                loadPositions: false
            }
        
        default:
            return state
    }
}